import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const BaseSection = memo(({ classNames, children }) => {
  const classes = cn('item-section item-section__residences', classNames);

  return <section className={classes}>{children}</section>;
});

BaseSection.propTypes = {
  children: PropTypes.node,
  classNames: PropTypes.string
};

BaseSection.displayName = 'BaseSection';

export default BaseSection;
